(function () {
  // https://stackoverflow.com/questions/35719526/safari-ignore-window-matchmedia/53788447#53788447
  window.mobile_query = window.matchMedia('screen and (max-width: 767px)')
  window.tablet_query = window.matchMedia('screen and (min-width: 768px)')
  window.desktop_query = window.matchMedia('screen and (min-width: 1025px)')
})();